import React, { useState, useEffect, useContext} from 'react';
import * as S from './styles';
import { Redirect } from 'react-router-dom';
import { Context } from '../../services/contexts/StateContext';
import api from '../../services/api';
import Cookies from 'js-cookie';

//---------COMPONENTES----------------------
import Header from '../../componentes/Header/index';
import Footer from '../../componentes/Footer/index';
import BarraLateral from '../../componentes/BarraLateral/index';

import {Load_Bola} from '../../componentes/loading/Func_Load';

//---------SERVICES--------------------------
import { ApiUsuario } from '../../services/FiltrosApi/logado';

// ----------ADD----------------------
import { ListaVistoria } from './ListaVistoria';
// ------------------------------------------
export function VistoriaLista() {
    const { state, dispatch } = useContext(Context);
    const { usuario, logado } = state.cliente;
    const { veiculo } = state.veiculo;
    const { evento } = state.evento;

    const { parametroInit, playmodal, listaPesquisa, playLista } = state.parametros;
    const {pesquisaIdUsuario} = parametroInit;

    const { id_Evento, codEvenBD } = evento;
    const { id_Usuario } = usuario;

    const [Statusconcluido, setCCConcluido] = useState('');
    const [valor_pago, setvalor_pago] = useState('');
    const [somaValorPago, setSomaValorPago] = useState('')
    const [valorPendente, setValorPend] = useState('');
    const [newValor_produtos, editValorProdutos] = useState('');
    const [newValor_servico, editValorServicos] = useState('');
    const [TotalEven, setTotalEven] = useState('');

    const { LogUsuario } = ApiUsuario();

    // --------------
    const token = Cookies.get('token');

    useEffect(() => {
        if (token) {
            LogUsuario(token);
        } else {
            dispatch({
                type: 'set_logado',
                payload: { ...logado, conectado: false }
            });
        }
    }, [token]);


    // -------------------
    useEffect(() => {
        if (pesquisaIdUsuario) {
            pesqIdUsuario();
        }
    }, [pesquisaIdUsuario])

    //--Pesquisar Usuario por id----------------------------
    async function pesqIdUsuario() {
        if (id_Usuario) {
            await api.get(`/usuario/id/${id_Usuario}`)
                .then(res => {
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: { ...listaPesquisa, listaUsuario: [res.data] }
                    });
                    dispatch({
                        type: 'set_playLista',
                        payload: { ...playLista, playListaUsuario: true }
                    });
                    dispatch({
                        type: 'SET_parametroInit',
                        payload: { ...parametroInit, pesquisaIdUsuario: false }
                    });

                })
        }
    };

    //-Atualizar Evento - Colocar como Pago "Statusconcluido" ou Aberto---------
    async function AtualizarConcluido() {
        if (somaValorPago >= TotalEven && Statusconcluido === false) {
            await api.put(`/evento/atualizar/${id_Evento}`, {
                Statusconcluido: true,
                data_modificado: Date.now(),

            }).then(res => {
                if (res.data.error) {
                    alert('erro')
                } else {
                    alert('Evento Pago!');
                }
            })
        };
        //--------
        if (somaValorPago < TotalEven && Statusconcluido === true) {
            await api.put(`/evento/atualizar/${id_Evento}`, {
                Statusconcluido: false,
                data_modificado: Date.now(),

            }).then(res => {
                if (res.data.error) {
                    alert('erro')
                } else {
                    alert('Evento Esta em Abeto!');
                }
            })
        };
    };

    //------------------------------------
    useEffect(() => {
        AtualizarConcluido()
    }, [somaValorPago && TotalEven && Statusconcluido])

    //----Valores Falta Pagar Pendente----
    useEffect(() => {
        setValorPend(TotalEven - somaValorPago)
    }, [valor_pago, newValor_servico, newValor_produtos, somaValorPago])

    // ---------------------------------
    useEffect(() => {
        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                detalhesLista: false,
                playModalDetalhesEven: false,
            }
        });
    }, [parametroInit.filtroPlaca])

    //------------Somar o Total-----------------
    const [Total, setTotal] = useState(0);
    let tt = parseFloat(newValor_servico) + parseFloat(newValor_produtos);

    useEffect(() => {
        if (tt) {
            setTotal(tt)
        }
    }, [tt])

    //-------------------Gerar Codigos-----------
    useEffect(() => {
        let inic = (1);
        let codinic = veiculo.placa + '-0' + inic;
        const regex = new RegExp(codinic, 'i'); // Expresao regular
        let verific = regex.test(codEvenBD) // verificar se ja existe este codigo no banco de dados
        //--------
        if (verific) { // se cod for igual, gerar novo
            for (; verific; inic++) {
                let codNovo = veiculo.placa + '-0' + inic
                const regex = new RegExp(codNovo, 'i');
                let verific = regex.test(codEvenBD)

                if (!verific) {
                    dispatch({
                        type: 'set_Evento',
                        payload: { ...evento, codEvento: codNovo }
                    });
                    break
                }
            };
        } else {
            if (veiculo.placa) {
                dispatch({
                    type: 'set_Evento',
                    payload: { ...evento, codEvento: codinic }
                });
            }
        }
    }, [codEvenBD && veiculo.placa]);

    console.log(listaPesquisa.listaCotacao)

    //###################################################################################################
    return (
        <S.App
        fundoBloque={
            playmodal.playModalEven && !parametroInit.detalhesLista ||
            playmodal.playModalEvenPlaca ||
            playmodal.playModalUsuario ||
            playmodal.playModalCliente ||
            playmodal.playModalVeiculo
        }>
            {!token && <Redirect to='/login' />}
            <div className='fundoBloque' />
            <Header playLogo={true} />
            <S.body>
                <BarraLateral />

                <S.body2>
                    <Load_Bola />

                    <ListaVistoria/>

                </S.body2>
            </S.body>
            <Footer />
        </S.App>
    )
}